import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PoEmailService } from "../../../../core/services/po-email.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { pluck } from "rxjs";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import { Title } from "@angular/platform-browser";
import { lastValueFrom } from "rxjs";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { Contact } from "../../../../core/models/shared/contact";
import { POEmailContact } from "../../../../core/models/orders/poEmailContact";
import { SalesOrderBCInformationDto } from "../../../../core/models/orders/salesOrderBCInformation";
import { VendorInformationForPOEmailDto } from "../../../../core/models/orders/vendorInformationForPOEmailDto";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";
import { FileUploadDto } from "../../../../core/models/shared/fileUploadDto";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { PurchaseOrderHeader } from "../../../../core/models/samplePO/details/samplePOSummaryDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { SamplepoSummaryService } from "../../../../core/services/samplepo-summary.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { GetPurchaseOrderConfirmationJournalRequest } from "../../../../core/models/orders/getPurchaseOrderConfirmationJournalRequest";
import { POEmailLogs } from "../../../../core/models/orders/poEmailLogs";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { CommonModule } from "@angular/common";
import { DisplayPdfFrameComponent } from "../display-pdf-frame/display-pdf-frame.component";
import { PoEmailHeaderComponent } from "../po-email-header/po-email-header.component";
import { PoEmailRecipientsComponent } from "../po-email-recipients/po-email-recipients.component";
import { PoEmailContactsComponent } from "../po-email-contacts/po-email-contacts.component";
import { PoEmailAttachmentsComponent } from "../po-email-attachments/po-email-attachments.component";
import { EditorComponent } from "../../../../shared/components/editor/editor.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-po-email",
  templateUrl: "./po-email.component.html",
  imports: [
    CommonModule,
    DisplayPdfFrameComponent,
    PoEmailHeaderComponent,
    PoEmailRecipientsComponent,
    PoEmailContactsComponent,
    PoEmailAttachmentsComponent,
    EditorComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
  styleUrls: ["./po-email.component.scss"],
})
@UntilDestroy()
export class PoEmailComponent implements OnInit, OnDestroy {
  poEmailForm!: FormGroup;
  poTemplates: EmailTemplates[] = [];
  vendorContacts: Contact[] = [];
  contacts: Contact[] = [];
  recipientsList: POEmailContact[] = [];
  loginUserInformation = {} as SalesOrderBCInformationDto;
  vendorInformation = {} as VendorInformationForPOEmailDto;
  poNumber = "";
  poJournalPdf = "";
  allBC: GetUserProjectDto[] = [];
  isBC = false;
  filesObject: FileUploadDto[] = [];
  totalFileSizeInKb = 0;
  bcPersonnelNumber = "";
  bacPersonnelNumber = "";
  userPersonnelNumber = "";
  userData!: GetUserDto;
  bcEmail = "";
  bacEmail = "";
  fileAttachmentUrlArray = new Map<string, string>();
  currentTemplete!: EmailTemplates;
  watermark = "";
  primaryVendorContactEmail = "";
  poJournalPdfStatus = false;
  poEmailDisplayModal = false;
  emailButtonStatus = false;
  poEmailScreenStatus = false;
  emailToArray: string[] = [];
  csvEmailTo = "";
  poJournalPdfUrl = "";
  @Input() poNumberParams = "";
  purchaseOrderHeader: PurchaseOrderHeader = {} as PurchaseOrderHeader;
  oldTitle = "";
  displaySendButton = true;
  @ViewChild("emailComponent", { static: false })
  emailComponent!: EditorComponent;

  formErrors: Record<string, string> = {
    subject: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    subject: {
      maxlength: "Subject must be less than 255 characters.",
    },
  };
  templateBody = "";
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _fb: FormBuilder,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _poEmailService: PoEmailService,
    private _saleOrderService: SaleOrderService,
    private _msalApisService: MsalApiService,
    private _samplepoListingService: SamplepoListingService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private titleService: Title,
    private _samplePOSummaryService: SamplepoSummaryService
  ) {}
  ngOnDestroy(): void {
    this.titleService.setTitle(this.oldTitle);
  }

  ngOnInit(): void {
    this.oldTitle = this.titleService.getTitle();
    this.initializeForm();
    this.setTitle(this.poNumberParams);
    this.getSaleOrderHeaderData(false);
    this.getPOTemplates();
    this.getUserProfile();
  }

  logValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  private initializeForm() {
    this.poEmailForm = this._fb.group({
      header: this._fb.group({
        templateId: [null],
        poNumber: [""],
        poNumberRevision: [{ value: "", disabled: true }],
        rush: [false],
        revised: [false],
        sender: [{ value: "", disabled: true }],
        subject: ["", [Validators.maxLength(255)]],
        additionalSubject: [""],
        reply: [{ value: "", disabled: true }],
      }),
    });
  }

  getPOTemplates() {
    this._loaderService.setLoaderState(true);
    this._poEmailService
      .getEmailTemplatesByType("PO-Email")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.poTemplates = res.data || [];
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getSaleOrderHeaderData(getloaderStatus: boolean) {
    if (this.poNumber) {
      this._loaderService.setLoaderState(getloaderStatus);
      this._samplePOSummaryService
        .getSamplePOSummary(this.poNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res?.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
              this.purchaseOrderHeader =
                res.data.purchaseOrderHeaderAddressDto.purchaseOrderHeader;
            } else {
              this._toastr.error(
                "Error",
                res.message || "Purchase Order Not Found"
              );
            }

            if (res?.data?.vendorContact) {
              this.contacts = (res.data.vendorContact as Contact[]).filter(
                x => x.typeD365?.toLowerCase() == "email"
              );
              this.vendorContacts = JSON.parse(JSON.stringify(this.contacts));
              const primaryContact = this.contacts.filter(
                x =>
                  x.isPrimaryD365?.toLowerCase() === "yes" &&
                  x.purposeD365?.toLowerCase()?.includes("business")
              );
              if (primaryContact.length > 0) {
                const object: POEmailContact = {
                  locatorD365: primaryContact[0].locatorD365,
                  descriptionD365: primaryContact[0].descriptionD365,
                  purposeD365: primaryContact[0].purposeD365,
                  isPrimaryD365: primaryContact[0].isPrimaryD365,
                  addType: "TO",
                  otherSpecification: "",
                  createdDate: "",
                  createdBy: "",
                  lastModifiedDate: null,
                  lastModifiedBy: null,
                  isActive: false,
                };
                this.primaryVendorContactEmail =
                  primaryContact[0].locatorD365 ?? "";
                this.recipientsList.push(object);
              }
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.userPersonnelNumber = res?.data?.personnelNumber;
          this.patchValueInSenderAndReply(res.data);
        }
      },
    });
  }

  patchValueInSenderAndReply(value: GetUserDto) {
    this.poEmailForm.patchValue({
      header: {
        sender: value.sendEmailAs || "",
        reply: value.displayEmailAs || "",
      },
    });
  }

  patchValueInRecipients(email: string) {
    const object: POEmailContact = {
      id: Date.now(),
      locatorD365: email,
      descriptionD365: "",
      purposeD365: "",
      isPrimaryD365: "",
      addType: "CC",
      otherSpecification: "",
      createdDate: "",
      createdBy: "",
      lastModifiedDate: null,
      lastModifiedBy: null,
      isActive: false,
    };
    this.recipientsList.push(object);
  }

  templatedSelected(id: number) {
    if (id > 0) {
      const index = this.poTemplates.findIndex(x => x.id == id);
      if (index > -1) {
        const template = this.poTemplates[index];
        this.currentTemplete = template;
        this.templateBody = template.body;
        //this.emailComponent.emailEditor.editor.setContent(template.body);
        if (this.vendorInformation.name) {
          this.patchValueInEditor();
        }
      }
    }
  }

  setTitle(poNumber: string) {
    this._poEmailService
      .getVendorInformationForPOEmail(poNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.titleService.setTitle(`${poNumber} - ${res?.data?.name || ""}`);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getAllBC() {
    this._samplepoListingService.getAllBrandingConsultant().subscribe({
      next: res => {
        if (res.status.toLowerCase() == "success") {
          this.allBC = res.data;
          const index = this.allBC.findIndex(
            x => x.personnelNumber == this.loginUserInformation.personnelNumber
          );
          if (index > -1) {
            this.isBC = true;
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  setSender() {
    // const userJson = localStorage.getItem("user") ?? "";
    // const userObject = JSON.parse(userJson);
    this.poEmailForm.patchValue({
      header: {
        sender: this.bcEmail,
      },
    });
  }

  getVendorInformationForPOEmail(poNumber: string) {
    this.emailButtonStatus = false;
    this.poNumber = poNumber;
    if (this.poNumber) {
      if (this.poEmailForm.get(["header", "rush"])?.value) {
        this._samplePOSummaryService
          .getPurchaseOrderConfirmationJournal(poNumber)
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.poJournalPdf = res.data;

                if (this.poJournalPdf) {
                  this.emailButtonStatus = true;
                }
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      } else if (this.poEmailForm.get(["header", "revised"])?.value) {
        this._samplePOSummaryService
          .getPurchaseOrderConfirmationJournal(poNumber)
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.poJournalPdf = res.data;

                if (this.poJournalPdf) {
                  this.emailButtonStatus = true;
                }
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      } else {
        this._samplePOSummaryService
          .getPurchaseOrderConfirmationJournal(poNumber)
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.poJournalPdf = res.data;

                if (this.poJournalPdf) {
                  this.emailButtonStatus = true;
                }
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      }

      this._poEmailService
        .getVendorInformationForPOEmail(poNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<VendorInformationForPOEmailDto>) => {
            this.vendorInformation = res.data;
            this.patchValueInEditor();
            if (res.status.toLowerCase() == "success") {
              this.getAllContactsByAccountNumber(
                this.vendorInformation.vendorAccountNumber,
                this.vendorInformation.partyNumber
              );
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });

      const poNumberObject: GetPurchaseOrderConfirmationJournalRequest = {
        purchaseOrderID: poNumber,
      };
      this._poEmailService
        .GetPurchaseOrderConfirmationJournal(poNumberObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.poEmailForm.patchValue({
                header: { poNumberRevision: res?.data?.PurchaseJournal ?? "" },
              });
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber = "") {
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(pluck("data"))
      .subscribe({
        next: data => {
          this.contacts = data.filter(
            x => x.typeD365?.toLowerCase() == "email"
          );
          this.vendorContacts = JSON.parse(JSON.stringify(this.contacts));
          const primaryContact = this.contacts.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" &&
              x.purposeD365?.toLowerCase()?.includes("business")
          );
          if (primaryContact.length > 0) {
            const object: POEmailContact = {
              locatorD365: primaryContact[0].locatorD365,
              descriptionD365: primaryContact[0].descriptionD365,
              purposeD365: primaryContact[0].purposeD365,
              isPrimaryD365: primaryContact[0].isPrimaryD365,
              addType: "TO",
              otherSpecification: "",
              createdDate: "",
              createdBy: "",
              lastModifiedDate: null,
              lastModifiedBy: null,
              isActive: false,
            };
            this.primaryVendorContactEmail =
              primaryContact[0].locatorD365 ?? "";
            this.recipientsList.push(object);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  addCC(addCCList: Contact[]) {
    addCCList.forEach(x => {
      const index = this.vendorContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.vendorContacts.splice(index, 1);
      }
      this.recipientsList.push({
        ...x,
        addType: "CC",
        descriptionD365: x.descriptionD365 ?? "",
      });
    });
  }

  addTO(addTOList: Contact[]) {
    addTOList.forEach(x => {
      const index = this.vendorContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.vendorContacts.splice(index, 1);
      }
      this.recipientsList.push({
        ...x,
        addType: "TO",
        descriptionD365: x.descriptionD365 ?? "",
      });
    });
  }

  recipientsDeleted(deletedList: POEmailContact[]) {
    for (const contact of deletedList) {
      const index = this.recipientsList.findIndex(x => x.id == contact.id);
      if (index > -1) {
        this.recipientsList.splice(index, 1);
      }
      if (this.contacts.findIndex(x => x.id == contact.id) > -1) {
        this.vendorContacts.push(contact);
      }
    }
  }

  recipientsAdd() {
    this.recipientsList.push({
      id: Date.now(),
      addType: "CC",
      locatorD365: "",
      firstNameD365: "",
      lastNameD365: "",
      typeD365: "",
      createdDate: new Date().toISOString(),
      createdBy: this.bcEmail,
      lastModifiedDate: new Date().toISOString(),
      lastModifiedBy: this.bcEmail,
      isActive: true,
      descriptionD365: undefined,
      otherSpecification: "",
    });
  }

  patchValueInEditor() {
    let content = this.templateBody; //this.emailComponent?.emailEditor?.editor?.getContent();
    if (content) {
      content = content.replace(
        "#{VendorLegalName}",
        this.vendorInformation.name
      );
      content = content.replace("#{PONumber}", this.poNumber);
      content = content.replace(
        "#{currentUser}",
        this.userData?.displayEmailAs || ""
      );
      content = content.replace("#{BCName}", this.userData?.name || "");
      this.templateBody = content;
      //this.emailComponent.emailEditor.editor.setContent(content);
    }
  }

  getAttachmentFileArray(event: FileUploadDto[]) {
    this.filesObject = event;
  }

  getTotalFileSize(event: number) {
    this.totalFileSizeInKb = event;
  }

  submitButtonlogValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  attachmentFileUrlArray(fileUrl: Map<string, string>) {
    this.fileAttachmentUrlArray = fileUrl;
  }

  async sendEmail(content: string) {
    this.submitButtonlogValidationErrors();
    this.csvEmailTo = "";
    if (!this.poEmailForm.valid) {
      return;
    }

    if (this.filesObject.length >= 250) {
      this._toastr.error(`File attachments must be less than 250`, "Error");
      return;
    }

    if (this.totalFileSizeInKb >= 33000) {
      this._toastr.error(
        `Total file attachments size must be less than 33MB`,
        "Error"
      );
      return;
    }

    const attachmentObject = {
      base64: this.poJournalPdf,
      fileExtension: ".pdf",
      fileId: 1,
      fileMimeType: "application/pdf",
      fileName: `${this.poNumber}.pdf`,
    } as FileUploadDto;
    const res = await lastValueFrom(
      this._poEmailService.getPoEmailAttachmentUrl(attachmentObject)
    );
    this.poJournalPdfUrl = res.data;

    const toRecipients: MicrosoftGraph.Recipient[] = [];
    const ccRecipients: MicrosoftGraph.Recipient[] = [];
    const to = this.recipientsList.filter(x => x.addType == "TO");
    const cc = this.recipientsList.filter(x => x.addType == "CC");

    for (const x of to) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        return;
      }
    }
    for (const x of cc) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        return;
      }
    }

    to.forEach(x => {
      toRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });
    cc.forEach(x => {
      ccRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });

    const attachement: MicrosoftGraph.Attachment[] = [];
    attachement.push({
      contentBytes: this.poJournalPdf,
      name: `${this.poNumber}.pdf`,
      contentType: "application/pdf",
      "@odata.type": "#microsoft.graph.fileAttachment",
    } as MicrosoftGraph.FileAttachment);

    if (this.filesObject.length > 0) {
      for (const key in this.filesObject) {
        attachement.push({
          contentBytes: this.filesObject[key].base64,
          name: `${this.filesObject[key].fileName}`,
          contentType: this.filesObject[key].fileMimeType,
          "@odata.type": "#microsoft.graph.fileAttachment",
        } as MicrosoftGraph.FileAttachment);
      }
    }

    let mailMessage: MicrosoftGraph.Message = {};
    const replyTo: MicrosoftGraph.Recipient[] = [
      {
        emailAddress: {
          address: this.poEmailForm.get(["header", "reply"])?.value || "",
        },
      },
    ];
    mailMessage = {
      subject: this.poEmailForm.get(["header", "subject"])?.value || "",
      body: {
        contentType: "html",
        content: content,
      },
      toRecipients: toRecipients,
      ccRecipients: ccRecipients,
      attachments: attachement,
      replyTo: replyTo,
    };

    const mail = {
      message: mailMessage,
    };

    this._loaderService.setLoaderState(true);
    this.displaySendButton = false;
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.success("Email Sent Successfully", "Success");
        this.sendEmailsLog(content, ccRecipients, toRecipients);
      },
      error: err => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          err?.error?.error?.message || "Unable To Send Mail",
          "Error"
        );
        this.displaySendButton = true;
      },
    });
  }

  sendEmailsLog(
    content: string,
    cc: MicrosoftGraph.Recipient[],
    to: MicrosoftGraph.Recipient[]
  ) {
    const attachementsArray = Array.from(this.fileAttachmentUrlArray).map(
      ([key, value]) => ({
        key,
        value,
      })
    );

    if (this.poJournalPdfUrl) {
      attachementsArray.push({
        key: `${this.poNumber}.pdf`,
        value: this.poJournalPdfUrl,
      });
    }

    const rush = this.poEmailForm.get(["header", "rush"])?.value;
    const revised = this.poEmailForm.get(["header", "revised"])?.value;
    if (rush && revised) {
      this.watermark = "All";
    } else if (rush) {
      this.watermark = "Rush";
    } else if (revised) {
      this.watermark = "Revised";
    } else {
      this.watermark = "";
    }

    const poEmailLogs = {
      templateId: this.currentTemplete?.id,
      additionalSubject: this.poEmailForm.get(["header", "additionalSubject"])
        ?.value,
      templateName: this.currentTemplete?.name,
      poNumber: this.poEmailForm.get(["header", "poNumber"])?.value,
      sender: this.poEmailForm.get(["header", "sender"])?.value,
      reply: this.poEmailForm.get(["header", "reply"])?.value,
      subject: this.poEmailForm.get(["header", "subject"])?.value,
      poRevisedVersion:
        this.poEmailForm.get(["header", "poNumberRevision"])?.value || "",
      attachement: JSON.stringify(attachementsArray),
      body: content,
      cc: JSON.stringify(cc),
      to: JSON.stringify(to),
      from: this.poEmailForm.get(["header", "sender"])?.value,
      id: 0,
      watermark: this.watermark,
    } as POEmailLogs;

    this._poEmailService.createPOEmailLogs(poEmailLogs).subscribe();
  }

  isValidEmail(email: string): boolean {
    const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
    if (RegExp(regex).exec(email)) {
      return true;
    }
    return false;
  }

  sendEmailEvent() {
    if (this.poJournalPdf) {
      this.poEmailDisplayModal = true;
    }
  }

  closeModal() {
    this.poEmailDisplayModal = false;
  }

  emailSelection() {
    this.poEmailScreenStatus = true;
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
